module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.4f724bff.woff2";